/* eslint-disable */

import axios from "axios";

const url = require("../../client_config/config").url;

const endpoints = 'meal-plans'

const state = {
  items: [],
  item: {},
  clientItems: []
};

const getters = {
  getAllItems: (state) => state.items,
  getItem: (state) => state.item,
  getClientItems: (state) => state.clientItems,
};

const actions = {
  async getItem({ commit }) {
    try {
      const response = await axios.get(`${url}/${endpoints}`);
      commit("SET_ITEMS", response.data.data);
      return response.data;
    } catch (error) {
      return error.response;
    }
  },

  async getItemById({commit}, id) {
    try {
      const response = await axios.get(`${url}/${endpoints}/${id}`);
      commit("SET_ITEM", response.data.data);
      return response.data;
    } catch (error) {
      return error.response;
    }
  },

  async getItemByClientId({commit}, id) {
    try {
      const response = await axios.get(`${url}/${endpoints}/client/${id}`);
      commit("SET_CLIENT_ITEMS", response.data.data);
      return response.data;
    } catch (error) {
      return error.response;
    }
  },

  async createItem({}, data) {
    try {
      const response = await axios.post(`${url}/${endpoints}`, data);
      return response;
    } catch (error) {
      console.log(error.response)
      return error.response;
    }
  },

  async updateItem({}, data) {
    try {
      const response = await axios.put(
        `${url}/${endpoints}/${data.id}`,
        data.data
      );
      return response;
    } catch (error) {
      return error.response;
    }
  },

  async deleteItem({}, id) {
    try {
      const response = await axios.delete(`${url}/${endpoints}/${id}`);
      return response.data;
    } catch (error) {
      return error.response;
    }
  },
};

const mutations = {
  SET_ITEMS(state, data) {
    state.items = data;
  },

  SET_ITEM(state, data) {
    state.item = data;
  },

  SET_CLIENT_ITEMS(state, data) {
    state.clientItems = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
